<template>

    <router-link :id='"#"+title' event="" :to="to" :style="computeBgStyle" class="container" @click.native.prevent="customTo(to)">
      
        <div class="flex-container">
          <div class="flex">
            <ui-icon class="ui-icon" v-if="icon" color="inherit" :icon="icon" background-color="transparent"/>{{$t(title)}}
          </div>
        </div>
    </router-link>

</template>

<script>
import { mapState } from 'vuex';
import UiIcon from '../UiIcon.vue';

export default {
  name: 'scroll-button',
  props:{
    enabled:{ default:true },
    title:{ default:"no-title"},
    to:{ default:"/" },
    icon:{ default:""},
    backgroundColor:{default:"#DDDDDD"},//F46767<-- red
    color:{default:"#FFFFFF"},
    fontSize:{default:"inherit"}
  },
  data(){
    return {
      //routerHasActiveClass:false
    }
  },
  computed:{
    ...mapState(['appSettings']),
    computeBgStyle(){
      var style={};
      style.backgroundColor=this.backgroundColor;
      style.color=this.color;//+this.appSettings.school_app_button_font_color;
      style.fontSize=this.fontSize;
      
      /*
      if(this.enabled){
        
        style.opacity="1";
      }else{
        
        style.opacity=".75";
      }
      */
      
      return style;
    },
  },
  methods:{
    customTo(url){

      // check if already active
      if( this.$el.classList.contains("router-link-active") || this.$el.classList.contains("router-link-exact-active")){
        return;
      }

      if(this.enabled){
        this.$router.push(url);
      }
      
    },
    getDynamicStyle(){
      var style={}
      style.color=this.color;//+this.appSettings.school_app_button_font_color;
      return style;
    },
    checkDirectLanding(){
      // if we direct land on a scrollbutton make sure we jump to it so its is visible
      
      
      if( this.$el.classList.contains("router-link-active") || this.$el.classList.contains("router-link-exact-active")){
       
       var offset=this.$el.offsetLeft;
       
        // emit to parent above
        let vm=this.$parent;
        while(vm){
          vm.$emit('SET_SCROLL_MENU_OFFSET_LEFT',offset)
          vm=vm.$parent;
        }
      }
    }
  },// methods
  components:{
    UiIcon,
  },
  
  mounted(){
    // check direct landing
    this.$nextTick(()=>{
       this.checkDirectLanding()
    })
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container{
  text-decoration:none;
  transition:background-color .25s;
  display:inline-block;
  flex:1;
  margin:2px;
  padding:8px 20px;
}
.flex-container{
  width:100%;
  height:100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  
}

.flex{
  display: flex;
    align-items: center;
    justify-content: center;
}
.ui-icon{
  font-size:inherit;
}

.router-link-active{
  color:#FFFFFF!important;
  background-color:#50c0db!important;
}
.router-link-exact-active{
  color:#FFFFFF!important;
  background-color:#50c0db!important;
}


</style>
